import React from 'react';
import './Injemoldiplastic.css';
import plastbot from '../../../imgs/plastbott.webp';

const Injemoldiplastic = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">Injection Molding Machines for Plastic Bottle Caps</h2>
                                <p className="Cavity-date">Oct. 11, 2022</p>

                <div className="Ordinary-content">
                   
                    <p className="Ordinary-text">Because different plastic bottles have different caps, there are strict requirements on air tightness to ensure the safety of items stored in plastic bottles. Therefore, producing
                         a high-quality plastic bottle cap has high requirements on the performance of the injection molding machines.</p>
                    <p className="Ordinary-text">Powerjet KII series high-precision injection molding machines and BJ series standard servo energy-saving injection molding machines are suitable for the production of multi-cavity mineral water bottle caps,
                         flip-top caps, threaded rotary caps, and other types.</p>
                <h3 className="Ordinary-title">KII High-precision Injection Molding Machine</h3>

                         <ul className="Ordinary-text">
                            <li>Using European high-end technology, suitable for high-precision and high-capacity plastic molding projects such as plastic bottle caps;</li>
                            <li>High injection speed, fast response, greatly shortening the cycle period</li>
                            <li>Precise control, using advanced controller, high-precision servo valve;</li>
                            <li>Using a high-response servo system, can save about 30%-70% of energy consumption;</li>
                            <li>Stable operation, low noise, and low vibration.</li>
                        </ul>
                </div>
                <div className="Ordinary">
                    <img src={plastbot} alt="72 Cavity PET Preforms Machine" className="Cavity-image"/>
                </div>
            </div>

        </div>
    );
};

export default Injemoldiplastic;
